import { defineComponent } from "vue";
import ColorSelector from "./component-library7.mjs";
const _sfc_main = defineComponent({
  name: "ProductOfferColorSelect",
  components: {
    ColorSelector
  },
  props: {
    offerColorVariants: {
      type: Array,
      required: true
    },
    value: { type: Number, default: null },
    noTitle: { type: Boolean }
  },
  emits: ["input"]
});
export {
  _sfc_main as default
};
